"use client"

import React, { useContext, useState, useEffect, useRef } from 'react'
import { motion } from "motion/react";
import { TextReveal } from './ui/typography';
import { Project } from './utils/interface';
import { useVariants } from '@/hooks/hooks';
import { Transition } from './ui/transitions';
import { ArrowUpRight } from './ui/icons';
import { ProjectsCopy } from '@/app/copywritting';
import { PortfolioContext } from '@/app/context/portfolioContext';
import Link from "next/link"

interface Props {
  containerRef?: React.RefObject<HTMLDivElement>;
  className?: string;
  height?: number;
}

const Portfolio = (props: Props) => {

  const { projects } = useContext(PortfolioContext);

  // const [filteredProjects, setFilteredProjects] = useState(projects);
  const [filterValue, setFilterValue] = useState("");
  const [showMore, setShowMore] = useState(false);
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);
  const numProjectToShow = 6;

  const { containerRef } = props;
  const [scrollProgress, setScrollProgress] = useState(0);
  const [scrollColorChange, setScrollColorChange] = useState(false);

  const displayProjects: Project[] = projects.sort((a,b) => a.sequence - b.sequence);
  useEffect(() => {

    const handleScroll = () => {
      const target = containerRef?.current || document.documentElement;
      const { scrollTop, scrollHeight, clientHeight } = target;
      const totalHeight = scrollHeight - clientHeight;
      const progress = (scrollTop / totalHeight) * 100;
      if (progress >= 39.5) {
        setScrollColorChange(true)
      } else {
        setScrollColorChange(false)
      }

    }
    window.addEventListener("scroll", handleScroll)
    return () => {window.removeEventListener("scroll", handleScroll)}
  }, [])
    

    // useEffect(() => {
    //     const filtered = applyFilters(projects, filterValue);
    //     setFilteredProjects(filtered);
    //   }, [filterValue, Projects]);

    //   const applyFilters = (data: Project[], filterValues: string) => {
    //     if (!filterValue || filterValues === "all") {
    //       return data;
    //     }
    
    //     return data.filter((project) =>
    //       project.techStack.some((tech) => filterValues === tech.trim())
    //     );
    //   };
      // console.log(projects, 'NOW')
  return (
    
    <section className="min-h-screen flex flex-col items-center p-6 pb-15">
        <h1 className="text-4xl md:text-big-heading font-bold pb-6 pt-20 md:pt-40 uppercase text-center tracking-tighter md:leading-heading">{ProjectsCopy.title}</h1>
      <p className={`w-full md:w-220 text-center text-medium md:text-xl pb-10 text-[#6d6e73] md:text-[#f8f8ff] leading-none md:leading-subheading text-wrap transition-colors duration-500 ease-in-out ${scrollColorChange ? "md:text-black" : "md:text-white"}`}>{ProjectsCopy.subtitle}</p>
       

        <motion.div className="relative grid md:grid-cols-3 grid-cols-2 md:gap-6 gap-3 ">
            {/* {filteredProjects
            .slice(0, showMore ? filteredProjects.length : numProjectToShow)
            .map((project, index) => (
                <Transition
                transition={{ delay: 0.2 + index * 0.1 }}
                viewport={{ once: true }}
                key={project._id}
                layoutId={project._id}
                onClick={() => {
                    setSelectedProject(project);
                }}>
                  
                <Card {...project} />
                </Transition>
            ))} */}
            
          
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 ">
          {displayProjects.slice(0,showMore ? displayProjects.length : numProjectToShow)
          .map((project) => (
            <motion.div
                  key={project._id}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  layout
                  className={`
                    rounded-xl md:rounded-3xl overflow-hidden shadow-md bg-[#fcfcff]
                    ${project.displaySize === "large" ? "md:col-span-2 md:row-span-2" : ""}
                    ${project.displaySize === "medium" ? "md:col-span-2 lg:col-span-1" : ""}
                  `}
                >
                  <Card {...project} />
                </motion.div>
          ))}
        </div>
        <div className="grid place-items-center py-4">
        {displayProjects.length > numProjectToShow && (
            <button
            className=" bg-[#0b0d15] flex items-center justify-center gap-4 py-3 px-6 rounded-md border mt-6 group relative overflow-hidden hover:bg-[#892CDC] text-[#f8f8ff] cursor-pointer font-bold tracking-wide"
            onClick={() => setShowMore(!showMore)}>
                <TextReveal>{showMore ? "Show less" : ProjectsCopy.cta_text}</TextReveal>
            </button>
        )}
        </div>
      </section>
  )
}

export default Portfolio

const Card = ({ projectId, title, name, mainImageUrl, short_description, industry }: Project) => {
    const [hover, setHover] = useState(false);
    const { setVariant } = useVariants();
  
    const mouseEnter = () => {
      setHover(true);
      setVariant("PROJECT");
    };
    const mouseLeave = () => {
      setHover(false);
      setVariant("DEFAULT");
    };
  
    return (
      <motion.div
        layout
        className="relative h-full rounded-xl md:rounded-3xl overflow-hidden md:px-4 cursor-pointer md:pb-[1.25rem] col-span-2"
        onMouseEnter={mouseEnter}
        onMouseLeave={mouseLeave}
      >
        <Link href={`/portfolio/${projectId}`}>
        <div className="md:py-8 relative">
          <motion.div className="flex justify-between items-center max-md:hidden" animate={{ y: hover ? -10 : 0 }} >
            <p className="text-sm md:text-xl font-bold uppercase max-md:opacity-0 tracking-tighter">
              {name}
            </p>
            {/* <button className="flex gap-2 items-center justify-center max-md:px-4"> */}
              <span className=" rounded-full p-1">
                <ArrowUpRight />
              </span>
            {/* </button> */}
          </motion.div>
          <div className="overflow-hidden max-md:hidden">
            <motion.p className="absolute text-[#6d6e73] font-semibold"
              initial={{ y: 0, opacity: 0 }}
              animate={{ y: hover ? -10 : 0, opacity: hover ? 1 : 0 }}>
              {industry}
            </motion.p>
          </div>
        </div>
        
        <img
          src={mainImageUrl}
          width={500}
          height={500}
          alt={title}
          className="object-cover w-full object-center rounded-xl md:rounded-t-3xl"
        />
        </Link>
      </motion.div>
    );
  };
